module.exports = __webpack_public_path__ + "static/kevin-kaninng-lg-39dc307781e46d6648d5181bda4d717e.png";